module.exports = __webpack_public_path__ + "static/media/moniviestin_logo_small.bf481845.svg";